import { ConsentBannerList } from './ConsentBannerList';
import { ConsentBannerShow } from './ConsentBannerShow';
import { ConsentBannerEdit } from './ConsentBannerEdit';
import { ConsentBannerCreate } from './ConsentBannerCreate';

export default {
  list: ConsentBannerList,
  show: ConsentBannerShow,
  edit: ConsentBannerEdit,
  create: ConsentBannerCreate,
};
